module.exports = __webpack_public_path__ + "img/logo-sm-dark.950b5f89.png";